"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import { AlertCircle, ArrowUpRight } from "@/components/icons";
import { SectionHeader } from "@/components/ui";
import { BRIGHTDATA_PROXY_TYPES_URL, PRICING_VERIFIED_DATE } from "./pricing-data";

const MotionDiv = motion.div;

export default function BrightDataMobileStatus() {
  const prefersReducedMotion = useReducedMotion();

  const fadeUp = (delay = 0) => ({
    initial: prefersReducedMotion ? {} : { opacity: 0, y: 24 },
    whileInView: prefersReducedMotion ? {} : { opacity: 1, y: 0 },
    viewport: scrollRevealViewport,
    transition: { duration: 0.55, delay },
  });

  return (
    <section className="py-section border-border border-b" aria-labelledby="mobile-status-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <MotionDiv {...fadeUp(0)} className="mb-10 max-w-2xl">
          <SectionHeader
            eyebrow="What Changed"
            id="mobile-status-heading"
            heading="Does Bright Data still offer mobile proxies?"
            body="Short answer: not as a publicly listed product. Here's exactly what their pages show."
          />
        </MotionDiv>

        <MotionDiv
          {...fadeUp(0.08)}
          className="border-border bg-card flex gap-4 rounded-xl border p-6 sm:p-7"
        >
          <AlertCircle
            size={20}
            className="mt-0.5 shrink-0"
            style={{ color: "var(--yellow-400)" }}
            aria-hidden="true"
          />
          <div>
            <p className="text-foreground text-sm leading-relaxed sm:text-base">
              Bright Data&rsquo;s current public proxy navigation lists three categories:
              Residential, ISP, and Datacenter. There is no mobile proxy category listed, and Bright
              Data&rsquo;s mobile-proxy product page now serves the same general proxy-types content
              instead of a standalone mobile offering.
            </p>
            <p className="text-muted-foreground mt-3 text-sm leading-relaxed">
              If you have an existing enterprise agreement with Bright Data, confirm current
              availability directly with their team. This page reflects what&rsquo;s publicly listed
              as of {PRICING_VERIFIED_DATE}.
            </p>
            <a
              href={BRIGHTDATA_PROXY_TYPES_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="text-muted-foreground hover:text-foreground mt-4 inline-flex items-center gap-1.5 text-sm font-medium transition-colors"
            >
              See Bright Data&rsquo;s current proxy pages
              <ArrowUpRight size={14} aria-hidden="true" />
            </a>
          </div>
        </MotionDiv>
      </div>
    </section>
  );
}
